// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CashbackEntityMapper from "../entity-mapper/CashbackEntityMapper.bs.js";
import * as CustomerEntityMapper from "../entity-mapper/CustomerEntityMapper.bs.js";
import * as ResendOTPEntityMapper from "../entity-mapper/ResendOTPEntityMapper.bs.js";
import * as VerifyOtpEntityMapper from "../entity-mapper/VerifyOtpEntityMapper.bs.js";
import * as VerifyEmailEntityMapper from "../entity-mapper/VerifyEmailEntityMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as CustomerOrderEntityMapper from "../entity-mapper/CustomerOrderEntityMapper.bs.js";
import * as WalletBalanceEntityMapper from "../entity-mapper/WalletBalanceEntityMapper.bs.js";
import * as CustomerConsentsEntityMapper from "../entity-mapper/CustomerConsentsEntityMapper.bs.js";
import * as CustomerUpdateErrorConverter from "../error-converter/CustomerUpdateErrorConverter.bs.js";
import * as PorterGoldDetailsEntityMapper from "../entity-mapper/PorterGoldDetailsEntityMapper.bs.js";
import * as AddSecondaryNumberEntityMapper from "../entity-mapper/AddSecondaryNumberEntityMapper.bs.js";
import * as SendPaymentRequestEntityMapper from "../entity-mapper/SendPaymentRequestEntityMapper.bs.js";
import * as TransactionHistoryEntityMapper from "../entity-mapper/TransactionHistoryEntityMapper.bs.js";
import * as UpdateCustomerConsentsEntityMapper from "../entity-mapper/UpdateCustomerConsentsEntityMapper.bs.js";

var execute = CustomerEntityMapper.execute;

var CustomerRepoConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var CustomerResponseConverter = partial_arg(CustomerRepoConfig, {
      execute: CustomerUpdateErrorConverter.execute
    });

var execute$1 = SendPaymentRequestEntityMapper.execute;

var SendPaymentRequestRepoConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var SendPaymentRequestResponseConverter = partial_arg$1(SendPaymentRequestRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$2 = CustomerOrderEntityMapper.execute;

var CustomerOrderRepoConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var CustomerOrderResponseConverter = partial_arg$2(CustomerOrderRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$3 = TransactionHistoryEntityMapper.execute;

var TransactionHistoryRepoConfig = {
  execute: execute$3
};

var partial_arg$3 = ResponseHandler$Catalyst.ResponseConverter;

var TransactionHistoryResponseConverter = partial_arg$3(TransactionHistoryRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$4 = AddSecondaryNumberEntityMapper.execute;

var AddSecondaryNumberRepoConfig = {
  execute: execute$4
};

var partial_arg$4 = ResponseHandler$Catalyst.ResponseConverter;

var AddSecondaryNumberResponseConverter = partial_arg$4(AddSecondaryNumberRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$5 = ResendOTPEntityMapper.execute;

var ResendOTPRepoConfig = {
  execute: execute$5
};

var partial_arg$5 = ResponseHandler$Catalyst.ResponseConverter;

var ResendOTPResponseConverter = partial_arg$5(ResendOTPRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$6 = VerifyOtpEntityMapper.execute;

var VerifyOtpRepoConfig = {
  execute: execute$6
};

var partial_arg$6 = ResponseHandler$Catalyst.ResponseConverter;

var VerifyOtpResponseConverter = partial_arg$6(VerifyOtpRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$7 = VerifyEmailEntityMapper.execute;

var VerifyEmailRepoConfig = {
  execute: execute$7
};

var partial_arg$7 = ResponseHandler$Catalyst.ResponseConverter;

var VerifyEmailResponseConverter = partial_arg$7(VerifyEmailRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$8 = WalletBalanceEntityMapper.execute;

var UpdateWalletBalanceRepoConfig = {
  execute: execute$8
};

var partial_arg$8 = ResponseHandler$Catalyst.ResponseConverter;

var UpdateWalletBalanceResponseConverter = partial_arg$8(UpdateWalletBalanceRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$9 = CashbackEntityMapper.execute;

var CashbackRepoConfig = {
  execute: execute$9
};

var partial_arg$9 = ResponseHandler$Catalyst.ResponseConverter;

var CashbackResponseConverter = partial_arg$9(CashbackRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$10 = PorterGoldDetailsEntityMapper.execute;

var PorterGoldDetailsRepoConfig = {
  execute: execute$10
};

var partial_arg$10 = ResponseHandler$Catalyst.ResponseConverter;

var PorterGoldDetailsResponseConverter = partial_arg$10(PorterGoldDetailsRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$11 = CustomerConsentsEntityMapper.execute;

var CustomerConsentsRepoConfig = {
  execute: execute$11
};

var partial_arg$11 = ResponseHandler$Catalyst.ResponseConverter;

var CustomerConsentsResponseConverter = partial_arg$11(CustomerConsentsRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$12 = UpdateCustomerConsentsEntityMapper.execute;

var UpdateCustomerConsentsRepoConfig = {
  execute: execute$12
};

var partial_arg$12 = ResponseHandler$Catalyst.ResponseConverter;

var UpdateCustomerConsentsResponseConverter = partial_arg$12(UpdateCustomerConsentsRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  CustomerRepoConfig ,
  CustomerResponseConverter ,
  SendPaymentRequestRepoConfig ,
  SendPaymentRequestResponseConverter ,
  CustomerOrderRepoConfig ,
  CustomerOrderResponseConverter ,
  TransactionHistoryRepoConfig ,
  TransactionHistoryResponseConverter ,
  AddSecondaryNumberRepoConfig ,
  AddSecondaryNumberResponseConverter ,
  ResendOTPRepoConfig ,
  ResendOTPResponseConverter ,
  VerifyOtpRepoConfig ,
  VerifyOtpResponseConverter ,
  VerifyEmailRepoConfig ,
  VerifyEmailResponseConverter ,
  UpdateWalletBalanceRepoConfig ,
  UpdateWalletBalanceResponseConverter ,
  CashbackRepoConfig ,
  CashbackResponseConverter ,
  PorterGoldDetailsRepoConfig ,
  PorterGoldDetailsResponseConverter ,
  CustomerConsentsRepoConfig ,
  CustomerConsentsResponseConverter ,
  UpdateCustomerConsentsRepoConfig ,
  UpdateCustomerConsentsResponseConverter ,
  
}
/* CustomerResponseConverter Not a pure module */
